import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, tap, timeout, retry } from 'rxjs/operators';

import { environment } from '../../../environments/environment';

import { SessionStorageService } from './session.service';

@Injectable({
  providedIn: 'root'
})
export class RestapiService {

  inernet_message: any = 'Ooops! You are not connected internet. Please check.';

  joseProperties = {
    alg: 'RSA-OAEP',
    use: 'enc'
  }
  encryptOptions = {
    format: 'compact',
    fields: {
      alg: 'RSA-OAEP',
      enc: 'A128CBC-HS256'
    }
  }
  keyType = "RSA";
  keySize = 512;
  PUBLICKEY = "-----BEGIN PUBLIC KEY-----\nMIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCkl/x3kJqPsq95ERwF7m0i1BkC\npTs78/FkxQzIcoVjX+79eiWZa0NwTzULXrtnqF7JIAiK8vfUxT9Pg4fx89LArrdn\n/Rl41GLXV3bfRGhrdljtdHIVE7L/BveyNjyzplvDDEdyjpq6Os2gGP87zzqDbcTf\nGUpRrgc4slXQb2DeKQIDAQAB\n-----END PUBLIC KEY-----"
  PRIVATEKEY = "-----BEGIN RSA PRIVATE KEY-----MIIEogIBAAKCAQEAnzyis1ZjfNB0bBgKFMSvvkTtwlvBsaJq7S5wA+kzeVOVpVWwkWdVha4s38XM/pa/yr47av7+z3VTmvDRyAHcaT92whREFpLv9cj5lTeJSibyr/Mrm/YtjCZVWgaOYIhwrXwKLqPr/11inWsAkfIytvHWTxZYEcXLgAXFuUuaS3uF9gEiNQwzGTU1v0FqkqTBr4B8nW3HCN47XUu0t8Y0e+lf4s4OxQawWD79J9/5d3Ry0vbV3Am1FtGJiJvOwRsIfVChDpYStTcHTCMqtvWbV6L11BWkpzGXSW4Hv43qa+GSYOD2QU68Mb59oSk2OB+BtOLpJofmbGEGgvmwyCI9MwIDAQABAoIBACiARq2wkltjtcjskFvZ7w1JAORHbEufEO1Eu27zOIlqbgyAcAl7q+/1bip4Z/x1IVES84/yTaM8p0goamMhvgry/mS8vNi1BN2SAZEnb/7xSxbflb70bX9RHLJqKnp5GZe2jexw+wyXlwaM+bclUCrh9e1ltH7IvUrRrQnFJfh+is1fRon9Co9Li0GwoN0x0byrrngU8Ak3Y6D9D8GjQA4Elm94ST3izJv8iCOLSDBmzsPsXfcCUZfmTfZ5DbUDMbMxRnSo3nQeoKGC0Lj9FkWcfmLcpGlSXTO+Ww1L7EGq+PT3NtRae1FZPwjddQ1/4V905kyQFLamAA5YlSpE2wkCgYEAy1OPLQcZt4NQnQzPz2SBJqQN2P5u3vXl+zNVKP8w4eBv0vWuJJF+hkGNnSxXQrTkvDOIUddSKOzHHgSg4nY6K02ecyT0PPm/UZvtRpWrnBjcEVtHEJNpbU9pLD5iZ0J9sbzPU/LxPmuAP2Bs8JmTn6aFRspFrP7W0s1Nmk2jsm0CgYEAyH0X+jpoqxj4efZfkUrg5GbSEhf+dZglf0tTOA5bVg8IYwtmNk/pniLG/zI7c+GlTc9BBwfMr59EzBq/eFMI7+LgXaVUsM/sS4Ry+yeK6SJx/otIMWtDfqxsLD8CPMCRvecC2Pip4uSgrl0MOebl9XKp57GoaUWRWRHqwV4Y6h8CgYAZhI4mh4qZtnhKjY4TKDjxQYufXSdLAi9v3FxmvchDwOgn4L+PRVdMwDNms2bsL0m5uPn104EzM6w1vzz1zwKz5pTpPI0OjgWN13Tq8+PKvm/4Ga2MjgOgPWQkslulO/oMcXbPwWC3hcRdr9tcQtn9Imf9n2spL/6EDFId+Hp/7QKBgAqlWdiXsWckdE1Fn91/NGHsc8syKvjjk1onDcw0NvVi5vcba9oGdElJX3e9mxqUKMrw7msJJv1MX8LWyMQC5L6YNYHDfbPF1q5L4i8j8mRex97UVokJQRRA452V2vCO6S5ETgpnad36de3MUxHgCOX3qL382Qx9/THVmbma3YfRAoGAUxL/Eu5yvMK8SAt/dJK6FedngcM3JEFNplmtLYVLWhkIlNRGDwkg3I5Ky18Ae9n7dHVueyslrb6weq7dTkYDi3iOYRW8HRkIQh06wEdbxt0shTzAJvvCQfrBjg/3747WSsf/zBTcHihTRBdAv6OmdhV4/dD5YBfLAkLrd+mX7iE=-----END RSA PRIVATE KEY-----";

  API_URL = environment.api_url;
  magicLink_url = environment.magicLink_url;
  CONTACT_API_URL = environment.contact_api_url;
  NEW_API_URL = environment.new_api_url;

  constructor(
    private location: Location,
    private http: HttpClient,
    private sessionService: SessionStorageService
  ) { }

  isLoggedIn() {
    return this.sessionService.getItemFromMemory('access_token');
  }

  private extractData(res: Response) {
    let resObj: any = res;
    return resObj || {};
  }

  /**
   * RBS Demo
   */
  postMagicLinkAPI(cPath: any, bodyObj: any): Observable<any> {

    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };
    if (navigator.onLine) {
      return this.http.post<any>(this.magicLink_url + cPath, bodyObj, httpOptions).pipe(
        timeout(30000),
        tap((data) => {
        }),
        map(this.extractData),
      );
    } else {
      window.alert(this.inernet_message);
    }
  }

  postAuthoriseAPI(cPath, bodyObj): Observable<any> {

    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };
    if (navigator.onLine) {
      return this.http.post<any>(cPath, bodyObj, httpOptions).pipe(
        timeout(30000),
        tap((data) => {
        }),
        map(this.extractData),
      );
    } else {
      window.alert(this.inernet_message);
    }
  }

  postAPI(cPath, bodyObj): Observable<any> {

    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };
    if (navigator.onLine) {
      return this.http.post<any>(this.API_URL + cPath, bodyObj, httpOptions).pipe(
        retry(3),
        timeout(120000),
        tap((data) => {
        }),
        map(this.extractData),
      );
    } else {
      window.alert(this.inernet_message);
    }
  }

  putAPI(cPath, bodyObj): Observable<any> {

    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };
    if (navigator.onLine) {
      return this.http.put<any>(this.API_URL + cPath, bodyObj, httpOptions).pipe(
        timeout(30000),
        tap((data) => {
        }),
        map(this.extractData),
      );
    } else {
      window.alert(this.inernet_message);
    }
  }

  patchAPI(cPath, bodyObj): Observable<any> {

    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };
    if (navigator.onLine) {
      return this.http.patch<any>(this.API_URL + cPath, bodyObj, httpOptions).pipe(
        timeout(30000),
        tap((data) => {
        }),
        map(this.extractData),
      );
    } else {
      window.alert(this.inernet_message);
    }
  }

  deleteAPI(cPath): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };
    if (navigator.onLine) {
      return this.http.delete<any>(this.API_URL + cPath, httpOptions);
    } else {
      window.alert(this.inernet_message);
    }
  }

  getAPI(cPath): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({})
    };
    if (navigator.onLine) {
      return this.http.get(this.API_URL + cPath, httpOptions).pipe(
        timeout(30000),
        tap((data) => {
        }),
        map(this.extractData),
      );
    } else {
      window.alert(this.inernet_message);
    }
  }

  async getSessionAPI(cPath: string) {
    let httpOptions = {
      headers: new HttpHeaders({})
    };

    return await this.http.get(this.API_URL + cPath, httpOptions).toPromise();
  }

  postcontactAPI(cPath, bodyObj): Observable<any> {

    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    if (navigator.onLine) {
      return this.http.post<any>(this.CONTACT_API_URL + cPath, bodyObj, httpOptions).pipe(
        timeout(30000),
        tap((data) => {
        }),
        map(this.extractData),
      );
    } else {
      window.alert(this.inernet_message);
    }
  }

  // Test API's
  getTestAPI(cPath): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({})
    };
    if (navigator.onLine) {
      return this.http.get(this.NEW_API_URL + cPath, httpOptions).pipe(
        timeout(30000),
        tap((data) => {
        }),
        map(this.extractData),
      );
    } else {
      window.alert(this.inernet_message);
    }
  }

  postTestAPI(cPath, bodyObj): Observable<any> {

    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };
    if (navigator.onLine) {
      return this.http.post<any>(this.NEW_API_URL + cPath, bodyObj, httpOptions).pipe(
        timeout(30000),
        tap((data) => {
        }),
        map(this.extractData),
      );
    } else {
      window.alert(this.inernet_message);
    }
  }
}
